class SvgLoader {
  key = "data";

  // Empty SVG fallback for missing/invalid files
  _fallbackSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"></svg>';

  async load(assetsPath) {
    const response = await fetch(assetsPath);

    if (!response.ok) {
      console.warn(`[AssetLoader] Failed to load SVG: ${response.statusText} (${assetsPath})`);
      return this._createFallback();
    }

    const content = await response.text();

    // Check if we received HTML instead of SVG (404 page)
    if (content.trim().startsWith('<!DOCTYPE') || content.trim().startsWith('<html')) {
      console.warn(`[AssetLoader] SVG file not found: ${assetsPath}`);
      return this._createFallback();
    }

    const parser = new DOMParser();
    const svgDocument = parser.parseFromString(content, 'image/svg+xml');

    // Check for parse errors
    const parseError = svgDocument.querySelector('parsererror');
    if (parseError) {
      console.warn(`[AssetLoader] Invalid SVG: ${assetsPath}`);
      return this._createFallback();
    }

    const svgElement = svgDocument.documentElement;
    return { content: svgElement, representation: content };
  }

  _createFallback() {
    const parser = new DOMParser();
    const svgDocument = parser.parseFromString(this._fallbackSvg, 'image/svg+xml');
    return { content: svgDocument.documentElement, representation: this._fallbackSvg };
  }
}

const svgLoader = new SvgLoader();
export { svgLoader, SvgLoader };
